[ {
  "code" : "V0-J0",
  "num" : 10,
  "label" : "VISIT J0",
  "forms" : [ {
    "study" : null,
    "code" : "F1",
    "labelCode" : "Eligibility criteria, Demography and MH",
    "fields" : [ {
      "labelCode" : "1. Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 2,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "ELIGIBILITY CRITERIA",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "IE",
      "metaData" : { }
    }, {
      "labelCode" : "Inclusion criteria",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : { }
    }, {
      "labelCode" : "1a - Regurgitations : Regurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "1",
        "IETEST" : " 1a. Regurgitations : Regurgitation 4 or more times per day, for 1 or more weeks",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "1b - Colic : Recurrent and prolonged periods of infant crying, fussing, or irritability reported by caregivers that occur without obvious cause and cannot be prevented or resolved by caregivers. No evidence of infant failure to thrive, fever, or illness.",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "2",
        "IETEST" : " 1b. Colic : Recurrent and prolonged periods of infant crying, fussing, or irritability reported by caregivers that occur without obvious cause and cannot be prevented or resolved by caregivers. No evidence of infant failure to thrive, fever, or illness. ",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "\n1c - Constipation, at least 2 of the following criteria : \n- Two or fewer defecations in the past week \n- History of excessive stool retention \n- History of painful or hard bowel movements \n- History of large-diameter stools \n- Presence of a large fecal mass in the rectum",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "3",
        "IETEST" : " 1c. Constipation, at least 2 of the following criteria : Two or fewer defecations in the past week / History of excessive stool retention / History of painful or hard bowel movements / History of large-diameter stools / Presence of a large fecal mass in the rectum",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "1- Infants presenting with at least 1 of the 3 FGIDs (regurgitations, constipation and/or colic) based on adapted Rome IV criteria",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "4",
        "IETEST" : " 1. Infants presenting with at least 1 of the 3 FGIDs (regurgitations, constipation and/or colic) based on adapted Rome IV criteria",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "2- Infants born at &ge; 35 weeks of gestational age",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "5",
        "IETEST" : " 2. Infants born at &ge; 35 weeks of gestational age",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "3- Infants up to 4 months of age",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "6",
        "IETEST" : " 3. Infants up to 4 months of age",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "4- Infants whose parents are able to comply with the protocol and fulfill an electronic diary",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "7",
        "IETEST" : " 4. Infants whose parents are able to comply with the protocol and fulfill an electronic diary",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "5- Infants whose parents / legal representatives signed the Informed Consent Form (ICF)",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "8",
        "IETEST" : " 5. Infants whose parents / legal representatives signed the Informed Consent Form (ICF)",
        "IECAT" : "INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "Non Inclusion criteria",
      "orderInForm" : 14,
      "type" : "title",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : { }
    }, {
      "labelCode" : "1- Exclusively or partially breastfed infants (i.e. > 2 breast feeds per day) with maternal willingness to continue breastfeeding",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "9",
        "IETEST" : " 1. Exclusively or partially breastfed infants (i.e. > 2 breast feeds per day) with maternal willingness to continue breastfeeding",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "2- Diversified infants or starting diversification within the first 2 weeks of the study",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "10",
        "IETEST" : " 2. Diversified infants or starting diversification within the first 2 weeks of the study",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "3- Infants with suspicion of digestive pathology or complicated gastroesophageal reflux disease (GERD) with oesophagitis suspicion ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "11",
        "IETEST" : " 3. Infants with suspicion of digestive pathology or complicated gastroesophageal reflux disease (GERD) with oesophagitis suspicion ",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "4- Infants with organic causes of constipation (e.g. coeliac disease, pediatric intestinal pseudo-obstruction, hypothyroidism, spina bifida, anorectal malformation or Hirschsprung’s disease) or any other gastrointestinal (GI) symptoms that are not functional in nature",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "12",
        "IETEST" : " 4. Infants with organic causes of constipation (e.g. coeliac disease, pediatric intestinal pseudo-obstruction, hypothyroidism, spina bifida, anorectal malformation or Hirschsprung’s disease) or any other gastrointestinal (GI) symptoms that are not functional in nature",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "5- Use of antibiotics at inclusion visit (V0) and within 7 days before the inclusion visit (V0).",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "13",
        "IETEST" : " 5. Use of antibiotics at inclusion visit (V0) and within 7 days before the inclusion visit (V0).",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "6- The willingness to take additional pre-, probiotics or thickening agents during the study.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "14",
        "IETEST" : " 6. The willingness to take additional pre-, probiotics or thickening agents during the study.",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "7- Known allergy/intolerance to any of the product ingredients or suspected allergy to cow’s milk requiring an eviction diet",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "15",
        "IETEST" : " 7. Known allergy/intolerance to any of the product ingredients or suspected allergy to cow’s milk requiring an eviction diet",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "8- Congenital condition and/or previous or current illness and/or medication use that could interfere with the main study outcomes according to the investigator",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "16",
        "IETEST" : " 8. Congenital condition and/or previous or current illness and/or medication use that could interfere with the main study outcomes according to the investigator",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "9- Infants presenting with any other situation including the participation in another clinical trial, which, according to the investigator, may interfere with the study participation, or lead to a particular risk for the patient",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "17",
        "IETEST" : " 9. Infants presenting with any other situation including the participation in another clinical trial, which, according to the investigator, may interfere with the study participation, or lead to a particular risk for the patient",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "10- Infants whose parents / legal representatives are not affiliated to a social security scheme",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "IEORRES",
      "datasetName" : "IE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "IESEQ" : "18",
        "IETEST" : " 10. Infants whose parents / legal representatives are not affiliated to a social security scheme",
        "IECAT" : "NON INCLUSION CRITERIA"
      }
    }, {
      "labelCode" : "INFORMED CONSENT FORM - ATTESTATION",
      "orderInForm" : 30,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 31,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Informed consent form - legal representative 1",
      "orderInForm" : 32,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Date of signature of the Informed Consent Form by the legal representative 1 (dd/mm/yyyy) ",
      "orderInForm" : 33,
      "type" : "qdate",
      "variableName" : "CONR1DTC",
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Agreement of the legal representative 1 for the re-use of the data collected ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "LR1AGR",
      "datasetName" : "DM",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Informed consent form - legal representative 2",
      "orderInForm" : 35,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Date of signature of the Informed Consent Form by the legal representative 2 (dd/mm/yyyy) ",
      "orderInForm" : 36,
      "type" : "qdate",
      "variableName" : "CONR2DTC",
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Agreement of the legal representative 2 for the re-use of the data collected ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "LR2AGR",
      "datasetName" : "DM",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Informed consent form - Investigator",
      "orderInForm" : 38,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Date of signature of the Informed Consent Form by the investigator (dd/mm/yyyy) ",
      "orderInForm" : 39,
      "type" : "qdate",
      "variableName" : "CONSIDTC",
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "FAMILY AND BIRTH DATA",
      "orderInForm" : 40,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Birth data",
      "orderInForm" : 41,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Date of birth (dd/mm/yyyy) ",
      "orderInForm" : 42,
      "type" : "qdate",
      "variableName" : "BRTHDTC",
      "datasetName" : "DM",
      "metaData" : { }
    }, {
      "labelCode" : "Gender",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "SEX",
      "datasetName" : "DM",
      "metaData" : {
        "LIST_CODE" : "SEX."
      }
    }, {
      "labelCode" : "Birth weight (kg)",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "BWEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use:  q.qqq (between 2.0-6.0 kg)",
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Birth length (cm)",
      "orderInForm" : 46,
      "type" : "qnumber",
      "variableName" : "BLENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: qq.q (between 40-60 cm)",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumderence at birth (cm)",
      "orderInForm" : 48,
      "type" : "qnumber",
      "variableName" : "BHEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: qq.q (between 30-45 cm)",
      "orderInForm" : 49,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Gestational age (weeks)",
      "orderInForm" : 50,
      "type" : "qnumber",
      "variableName" : "GESTAGEW",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: between 35-42 weeks ",
      "orderInForm" : 51,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Gestational age (days)",
      "orderInForm" : 52,
      "type" : "qnumber",
      "variableName" : "GESTAGED",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Please use:  0-6 days",
      "orderInForm" : 53,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Method of determination of gestional age",
      "orderInForm" : 54,
      "type" : "list",
      "variableName" : "GESTAGEM",
      "datasetName" : "SC",
      "metaData" : {
        "LIST_CODE" : "GA."
      }
    }, {
      "labelCode" : "Mode of delivery",
      "orderInForm" : 55,
      "type" : "list",
      "variableName" : "SCMODLV",
      "datasetName" : "SC",
      "metaData" : {
        "LIST_CODE" : "MD."
      }
    }, {
      "labelCode" : "Number of infants born alive from the same pregnancy",
      "orderInForm" : 56,
      "type" : "qnumber",
      "variableName" : "SCINFBAL",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Rank of this pregnancy ",
      "orderInForm" : 57,
      "type" : "qnumber",
      "variableName" : "SCRANK",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Family data",
      "orderInForm" : 58,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Father's Height (cm)",
      "orderInForm" : 59,
      "type" : "qnumber",
      "variableName" : "FHEIGHTF",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Father's Weight (kg)",
      "orderInForm" : 60,
      "type" : "qnumber",
      "variableName" : "FHWEIGF",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Mother's Height (cm)",
      "orderInForm" : 61,
      "type" : "qnumber",
      "variableName" : "FHEIGHTM",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Mother's Weight (kg)",
      "orderInForm" : 62,
      "type" : "qnumber",
      "variableName" : "FHWEIGM",
      "datasetName" : "SC",
      "metaData" : { }
    }, {
      "labelCode" : "Mother's weight measured",
      "orderInForm" : 63,
      "type" : "list",
      "variableName" : "FHWMEAS",
      "datasetName" : "SC",
      "metaData" : {
        "LIST_CODE" : "WM."
      }
    }, {
      "labelCode" : "MEDICAL HISTORY OF THE CHILD",
      "orderInForm" : 64,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Any other pathology ? other than regurgitations, colics and constipation",
      "orderInForm" : 65,
      "type" : "list",
      "variableName" : "MHYN",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : " => If yes, please specify :",
      "orderInForm" : 66,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nervous system   ",
      "orderInForm" : 67,
      "type" : "qmulti",
      "variableName" : "MHTERM01",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Eyes   ",
      "orderInForm" : 68,
      "type" : "qmulti",
      "variableName" : "MHTERM02",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Ears   ",
      "orderInForm" : 69,
      "type" : "qmulti",
      "variableName" : "MHTERM03",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Respiratory system   ",
      "orderInForm" : 70,
      "type" : "qmulti",
      "variableName" : "MHTERM04",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Cardiac system   ",
      "orderInForm" : 71,
      "type" : "qmulti",
      "variableName" : "MHTERM05",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Vascular system   ",
      "orderInForm" : 72,
      "type" : "qmulti",
      "variableName" : "MHTERM06",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Gastrointestinal system   ",
      "orderInForm" : 73,
      "type" : "qmulti",
      "variableName" : "MHTERM07",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Hepatobiliary system   ",
      "orderInForm" : 74,
      "type" : "qmulti",
      "variableName" : "MHTERM08",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Renal and urinary system   ",
      "orderInForm" : 75,
      "type" : "qmulti",
      "variableName" : "MHTERM09",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Reproductive system   ",
      "orderInForm" : 76,
      "type" : "qmulti",
      "variableName" : "MHTERM10",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Endocrine system   ",
      "orderInForm" : 77,
      "type" : "qmulti",
      "variableName" : "MHTERM11",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Metabolism and nutrition disorders    ",
      "orderInForm" : 78,
      "type" : "qmulti",
      "variableName" : "MHTERM12",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Infections and infestations   ",
      "orderInForm" : 79,
      "type" : "qmulti",
      "variableName" : "MHTERM13",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Musculoskeletal and connective tissue disorders   ",
      "orderInForm" : 80,
      "type" : "qmulti",
      "variableName" : "MHTERM14",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Immune system disorders   ",
      "orderInForm" : 81,
      "type" : "qmulti",
      "variableName" : "MHTERM15",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Blood and lymphatic system disorders   ",
      "orderInForm" : 82,
      "type" : "qmulti",
      "variableName" : "MHTERM16",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Skin and subcutaneous tissue disorders   ",
      "orderInForm" : 83,
      "type" : "qmulti",
      "variableName" : "MHTERM17",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Congenital, familial and genetic disorders   ",
      "orderInForm" : 84,
      "type" : "qmulti",
      "variableName" : "MHTERM18",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Surgical and medical procedures    ",
      "orderInForm" : 85,
      "type" : "qmulti",
      "variableName" : "MHTERM19",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "Other ",
      "orderInForm" : 86,
      "type" : "qmulti",
      "variableName" : "MHTERM20",
      "datasetName" : "MH",
      "metaData" : {
        "LIST_CODE" : "Yes."
      }
    }, {
      "labelCode" : "  => Please specify :",
      "orderInForm" : 87,
      "type" : "qtext",
      "variableName" : "MHTERM21",
      "datasetName" : "MH",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_ANTHROPO",
    "labelCode" : "Anthropometric measures",
    "fields" : [ {
      "labelCode" : "ANTHROPOMETRIC MEASURES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Weight (kg)",
      "orderInForm" : 3,
      "type" : "qnumber",
      "variableName" : "WEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Length (cm)",
      "orderInForm" : 5,
      "type" : "qnumber",
      "variableName" : "LENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumference (cm)",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "HEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_FEEDING",
    "labelCode" : "Feeding",
    "fields" : [ {
      "labelCode" : "FEEDING",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Feeding history",
      "orderInForm" : 3,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant been breastfed?",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "BREASTFD",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "YNK."
      }
    }, {
      "labelCode" : "End date of breastfeeding (dd/mm/yyyy) ",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "BRSFEDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Start date of the first infant formula  (dd/mm/yyyy) ",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "FEEDFDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Name of the current formula",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "FEEDFOR",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Brand of the current formula",
      "orderInForm" : 8,
      "type" : "qtext",
      "variableName" : "FEEDBRAN",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Start date of the current formula ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FORMSTU",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "DWM."
      }
    }, {
      "labelCode" : " => Please specify  a date (dd/mm/yyyy)",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FORMSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : " => Please specify a number",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "FORMSDUR",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Feeding data",
      "orderInForm" : 13,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average number of bottles per day (24h) over the last 3 days (bottles/day)",
      "orderInForm" : 14,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Average volume of bottles over the last 3 days (ml/bottle)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "OR",
      "orderInForm" : 17,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average total daily consumption of formula over the last 3 days(ml/day)",
      "orderInForm" : 19,
      "type" : "qnumber",
      "variableName" : "FEEDVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 20,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 21,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average number of night feedings over the last 3 days (bottles/night)",
      "orderInForm" : 22,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Frequency of use of magnesium-rich water (e.g. Hépar®) ?",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "FEEDMGW1",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQF."
      }
    }, {
      "labelCode" : "Feeding refusal frequency over the last 3 days",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "FEEDREF1",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2F."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_Regurg",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average number of regurgitations per day, over the last 3 days (regurgitations /day)",
      "orderInForm" : 3,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average volume of regurgitations, over the last 3 days",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGG."
      }
    }, {
      "labelCode" : "Frequency of regurgitation away from meals (more than 1 hour after the end of the meal), over the last 3 days",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQ."
      }
    }, {
      "labelCode" : "Continuous regurgitations of small volumes during more than 30 minutes after each feeding, over the last 3 days",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQ."
      }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_Nconstip",
    "labelCode" : "Stools (non-constipated infants)",
    "fields" : [ {
      "labelCode" : "STOOLS (NON-CONSTIPATED INFANTS)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average main stool consistency, over the last 3 days",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL."
      }
    }, {
      "labelCode" : "If Other, comment for consistency",
      "orderInForm" : 5,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average number of stools per day, over the last 3 days",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_constip",
    "labelCode" : "Stools (constipated infants)",
    "fields" : [ {
      "labelCode" : "STOOLS (CONSTIPATED INFANTS)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Number of hard stools, over the last 7 days",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Number of formed stools, over the last 7 days",
      "orderInForm" : 5,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Number of loose stools, over the last 7 days",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Number of watery stools, over the last 7 days",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Total number of stools, over the last 7 days",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "How often has the defecation been painful for the infant, over the last 7 days ?",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN."
      }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_COLIC",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average abdominal distension severity according to parents, over the last 3 days",
      "orderInForm" : 5,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: qq.q between 0 (no symptoms) and 10 (very severe symptoms)",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average gas/flatulence severity according to parents, over the last 3 days",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: qq.q between 0 (no symptoms) and 10 (very severe symptoms)",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Average unexplained crying time / day, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "Average fussing/irritability duration / day, over the last 3 days",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F1_SLEEP",
    "labelCode" : "Sleeping",
    "fields" : [ {
      "labelCode" : "SLEEPING",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average sleep duration per day, over the last 3 days",
      "orderInForm" : 3,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Average sleep quality, over the last 3 days",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Please use: qq.q between 0 (difficult to fall asleep, frequent awakenings) and 10 (easy to fall asleep quickly, no awakenings without obvious cause)",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE_J0",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "F5_TRT",
    "labelCode" : "Treatment during the preceding week (eCRF – Investigateur) ",
    "fields" : [ {
      "labelCode" : "TREATMENT DURING THE PRECEDING WEEK",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "CM",
      "metaData" : { }
    }, {
      "labelCode" : "Treatment / medication taken  (including thickening agent, pre-probiotics, laxative…)",
      "orderInForm" : 4,
      "type" : "qtext",
      "variableName" : "CMTRT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Route",
      "orderInForm" : 5,
      "type" : "qlist",
      "variableName" : "CMROUTE",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "ROUTE.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Dose",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "CMDOSTXT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Dose Unit",
      "orderInForm" : 7,
      "type" : "qlist",
      "variableName" : "CMDOSU",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "UNIT.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "if other: Unit",
      "orderInForm" : 8,
      "type" : "qtext",
      "variableName" : "CMDOSUOT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Frequency",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "CMDOSFRQ",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Start date (dd/mm/yyyy) ",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "CMSTDTC",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Ongoing",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "CMONGO",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "End date (dd/mm/yyyy) ",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "CMENDTC",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Indication",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "CMINDC",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "INDIC.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "If Indication is MH, Prophylaxis or Other, please specify",
      "orderInForm" : 17,
      "type" : "qtext",
      "variableName" : "CMINDCSP",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "TINS",
    "labelCode" : "New appointment - Tins delivery",
    "fields" : [ {
      "labelCode" : "NEW APPOINTMENT AND TINS DELIVERY",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "ePRO handling",
      "orderInForm" : 3,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Have the parents received the instructions to complete the electronic diary (ePRO) daily during the next 14 days?",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "DIARINS",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Have parents received their access to the electronic journal (ePRO)? ",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "DIACCESS",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "New appointment ",
      "orderInForm" : 6,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has a new appointment been scheduled?",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "APPSCHED",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Tins delivered",
      "orderInForm" : 8,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "How many tins were provided to the parents?",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "TINSNB",
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : "Tins delivery",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : "Has the tins delivery request been processed? ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "TINRQPRO",
      "datasetName" : "DA",
      "metaData" : {
        "LIST_CODE" : "YN."
      }
    }, {
      "labelCode" : "Number of tins delivered",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "TINSREQ",
      "datasetName" : "DA",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "J7",
  "num" : 20,
  "label" : "VISIT J7",
  "forms" : [ {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "V1-J14",
  "num" : 30,
  "label" : "VISIT J14",
  "forms" : [ {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "DIVERSIFJ14",
    "labelCode" : "Diversification",
    "fields" : [ {
      "labelCode" : "DIVERSIFICATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 3,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant started diversification since the last visit?",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "FEEDIV",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When (dd/mm/yyyy)  ?",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FDIVDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "RegurgJ14",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (Régurgitations) before completing this one",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the infant have regurgitation according to the adapted Rome IV criteria? \n",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "\nRegurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy)  ?  ",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "STOOLJ14",
    "labelCode" : "Stools",
    "fields" : [ {
      "labelCode" : "STOOLS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Please consult the previous form (SELLES ENFANTS CONSTIPES / NON CONSTIPES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Is the infant constipated according to rome IV criteria",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "COLICJ14",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (DISTENSION ABDOMINALE ET FLATULENCES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the child have colic according to Rome IV criteria?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 8,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE_J14",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Please check also the filled scores for the questionnaires GIGER and QUALIN at J7 ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "EFFIC",
    "labelCode" : "Investigator's evaluation of the evolution of FGIDs",
    "fields" : [ {
      "labelCode" : "EVOLUTION OF FUNCTIONAL GASTROINTESTINAL DISORDERS (FGIDs)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution of regurgitation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "REGUREV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of constipation",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "CONSTEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of colic",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "COLICEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "TINSb",
    "labelCode" : "Study continuation - Tins delivery",
    "fields" : [ {
      "labelCode" : "STUDY CONTINUATION AND TINS DELIVERY",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Study continuation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "STDCONT",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "If no, please complete the section \"Study end\"",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "New appointment ",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has a new appointment been scheduled?",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "APPSCHED",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Next visit date",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "NEXSVDTC",
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Tins delivery",
      "orderInForm" : 8,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has the tins delivery request been processed? ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "TINRQPRO",
      "datasetName" : "DA",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Number of tins delivered",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "TINSREQ",
      "datasetName" : "DA",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "V2-J30",
  "num" : 40,
  "label" : "VISIT J30",
  "forms" : [ {
    "study" : null,
    "code" : "ANTHROPO",
    "labelCode" : "Anthropometric measures",
    "fields" : [ {
      "labelCode" : "ANTHROPOMETRIC MEASURES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 3,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "Weight (kg)",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "WEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Length (cm)",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "LENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumference (cm)",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "HEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "DIVERSIFJ30",
    "labelCode" : "Diversification",
    "fields" : [ {
      "labelCode" : "DIVERSIFICATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant started diversification since the last visit?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FEEDIV",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When (dd/mm/yyyy)  ?",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FDIVDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "DIVERSIFJ14.FEEDIV = 0"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "RegurgJ30",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (Régurgitations) before completing this one",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the infant have regurgitation according to the adapted Rome IV criteria? \n",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "\nRegurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy)  ?  ",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "STOOLJ30",
    "labelCode" : "Stools",
    "fields" : [ {
      "labelCode" : "STOOLS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Please consult the previous form (SELLES ENFANTS CONSTIPES / NON CONSTIPES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Is the infant constipated according to rome IV criteria",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "COLICJ30",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (DISTENSION ABDOMINALE ET FLATULENCES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the child have colic according to Rome IV criteria?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 8,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_J30_INV",
    "labelCode" : "GIGER with investigator (if missing data at D30 )",
    "fields" : [ {
      "labelCode" : "GIGER WITH INVESTIGATOR",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : "This questionnaire is about your child's gastro-oesophageal reflux and gastrointestinal symptoms. To complete it, look at what your child has been experiencing over the past week and then tick the box corresponding to your answer for each item (from 1 to 36).",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : "My child…",
      "orderInForm" : 6,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER TOTAL SCORE",
      "orderInForm" : 43,
      "type" : "qnumber",
      "variableName" : "GIGER_ISC",
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : "If you would like to explain any of your answers or provide additional information, please do so here",
      "orderInForm" : 44,
      "type" : "qtext",
      "variableName" : "GIGERICO",
      "datasetName" : "GIGERI",
      "metaData" : { }
    }, {
      "labelCode" : "Investigator completion Q1",
      "orderInForm" : 7,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q1",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q2",
      "orderInForm" : 8,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q2",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q3",
      "orderInForm" : 9,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q3",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q4",
      "orderInForm" : 10,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q4",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q5",
      "orderInForm" : 11,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q5",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q6",
      "orderInForm" : 12,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q6",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q7",
      "orderInForm" : 13,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q7",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q8",
      "orderInForm" : 14,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q8",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q9",
      "orderInForm" : 15,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q9",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q10",
      "orderInForm" : 16,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q10",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q11",
      "orderInForm" : 17,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q11",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q12",
      "orderInForm" : 18,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q12",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q13",
      "orderInForm" : 19,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q13",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q14",
      "orderInForm" : 20,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q14",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q15",
      "orderInForm" : 21,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q15",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q16",
      "orderInForm" : 22,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q16",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q17",
      "orderInForm" : 23,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q17",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q18",
      "orderInForm" : 24,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q18",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q19",
      "orderInForm" : 25,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q19",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q20",
      "orderInForm" : 26,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q20",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q21",
      "orderInForm" : 27,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q21",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q22",
      "orderInForm" : 28,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q22",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q23",
      "orderInForm" : 29,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q23",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q24",
      "orderInForm" : 30,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q24",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q25",
      "orderInForm" : 31,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q25",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q26",
      "orderInForm" : 32,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q26",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q27",
      "orderInForm" : 33,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q27",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q28",
      "orderInForm" : 34,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q28",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q29",
      "orderInForm" : 35,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q29",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q30",
      "orderInForm" : 36,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q30",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q31",
      "orderInForm" : 37,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q31",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q32",
      "orderInForm" : 38,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q32",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q33",
      "orderInForm" : 39,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q33",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q34",
      "orderInForm" : 40,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q34",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q35",
      "orderInForm" : 41,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q35",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "Investigator completion Q36",
      "orderInForm" : 42,
      "type" : "qlist",
      "variableName" : "QSORRESI",
      "datasetName" : "GIGERI",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " Investigator completion Q36",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER WITH INVESTIGATOR"
      }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 1",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 8,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 2",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 3",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 10,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 4",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 11,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 5",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 12,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 6",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 13,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 7",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 8",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 15,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 9",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 16,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 10",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 17,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 11",
        "QSTEST" : " 11.My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 18,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 12",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 19,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 13",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 20,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 14",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 21,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 15",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 22,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 16",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 23,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 17",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 18",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 19",
        "QSTEST" : " 19. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 26,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 20",
        "QSTEST" : " 20. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 27,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 21",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 28,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 22",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 29,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 23",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 30,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 24",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 31,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 25",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 32,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 26",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 33,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 27",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 34,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 28",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 35,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 29",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 36,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 30",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 37,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 31",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 38,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 32",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 39,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 33",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 40,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 34",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 41,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 35",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 42,
      "type" : "qtext",
      "variableName" : "QSORRESD",
      "datasetName" : "GIGERD",
      "metaData" : {
        "QSSEQ" : " 36",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER (REPORTED VALUE)"
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "EFFIC",
    "labelCode" : "Investigator's evaluation of the evolution of FGIDs",
    "fields" : [ {
      "labelCode" : "EVOLUTION OF FUNCTIONAL GASTROINTESTINAL DISORDERS (FGIDs)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution of regurgitation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "REGUREV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of constipation",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "CONSTEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of colic",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "COLICEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "TINSb",
    "labelCode" : "Study continuation - Tins delivery",
    "fields" : [ {
      "labelCode" : "STUDY CONTINUATION AND TINS DELIVERY",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Study continuation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "STDCONT",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "If no, please complete the section \"Study end\"",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "New appointment ",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has a new appointment been scheduled?",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "APPSCHED",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Next visit date",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "NEXSVDTC",
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Tins delivery",
      "orderInForm" : 8,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has the tins delivery request been processed? ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "TINRQPRO",
      "datasetName" : "DA",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Number of tins delivered",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "TINSREQ",
      "datasetName" : "DA",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "V3-J60",
  "num" : 50,
  "label" : "VISIT J60",
  "forms" : [ {
    "study" : null,
    "code" : "ANTHROPO",
    "labelCode" : "Anthropometric measures",
    "fields" : [ {
      "labelCode" : "ANTHROPOMETRIC MEASURES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 3,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "Weight (kg)",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "WEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Length (cm)",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "LENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumference (cm)",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "HEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "DIVERSIFJ60",
    "labelCode" : "Diversification",
    "fields" : [ {
      "labelCode" : "DIVERSIFICATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant started diversification since the last visit?",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FEEDIV",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When (dd/mm/yyyy)  ?",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FDIVDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "DIVERSIFJ30.FEEDIV = 0"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "RegurgJ60",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (Régurgitations) before completing this one",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the infant have regurgitation according to the adapted Rome IV criteria? \n",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "\nRegurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy)  ?  ",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "STOOLJ60",
    "labelCode" : "Stools",
    "fields" : [ {
      "labelCode" : "STOOLS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Please consult the previous form (SELLES ENFANTS CONSTIPES / NON CONSTIPES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Is the infant constipated according to rome IV criteria",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "COLICJ60",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (DISTENSION ABDOMINALE ET FLATULENCES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the child have colic according to Rome IV criteria?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 8,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "EFFIC",
    "labelCode" : "Investigator's evaluation of the evolution of FGIDs",
    "fields" : [ {
      "labelCode" : "EVOLUTION OF FUNCTIONAL GASTROINTESTINAL DISORDERS (FGIDs)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution of regurgitation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "REGUREV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of constipation",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "CONSTEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of colic",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "COLICEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "TINSb",
    "labelCode" : "Study continuation - Tins delivery",
    "fields" : [ {
      "labelCode" : "STUDY CONTINUATION AND TINS DELIVERY",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Study continuation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "STDCONT",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "If no, please complete the section \"Study end\"",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "New appointment ",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has a new appointment been scheduled?",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "APPSCHED",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Next visit date",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "NEXSVDTC",
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Tins delivery",
      "orderInForm" : 8,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has the tins delivery request been processed? ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "TINRQPRO",
      "datasetName" : "DA",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Number of tins delivered",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "TINSREQ",
      "datasetName" : "DA",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "V4-J90",
  "num" : 60,
  "label" : "VISIT J90",
  "forms" : [ {
    "study" : null,
    "code" : "ANTHROPO",
    "labelCode" : "Anthropometric measures",
    "fields" : [ {
      "labelCode" : "ANTHROPOMETRIC MEASURES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 3,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "Weight (kg)",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "WEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Length (cm)",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "LENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumference (cm)",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "HEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "DIVERSIFJ90",
    "labelCode" : "Diversification",
    "fields" : [ {
      "labelCode" : "DIVERSIFICATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant started diversification since the last visit?",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "FEEDIV",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When (dd/mm/yyyy)  ?",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FDIVDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "DIVERSIFJ60.FEEDIV = 0"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "RegurgJ90",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (Régurgitations) before completing this one",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the infant have regurgitation according to the adapted Rome IV criteria? \n",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "\nRegurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy)  ?  ",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "STOOLJ90",
    "labelCode" : "Stools",
    "fields" : [ {
      "labelCode" : "STOOLS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Please consult the previous form (SELLES ENFANTS CONSTIPES / NON CONSTIPES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Is the infant constipated according to rome IV criteria",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "COLICJ90",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (DISTENSION ABDOMINALE ET FLATULENCES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the child have colic according to Rome IV criteria?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 8,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "EFFIC",
    "labelCode" : "Investigator's evaluation of the evolution of FGIDs",
    "fields" : [ {
      "labelCode" : "EVOLUTION OF FUNCTIONAL GASTROINTESTINAL DISORDERS (FGIDs)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution of regurgitation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "REGUREV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of constipation",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "CONSTEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of colic",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "COLICEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "TINSb",
    "labelCode" : "Study continuation - Tins delivery",
    "fields" : [ {
      "labelCode" : "STUDY CONTINUATION AND TINS DELIVERY",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Study continuation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "STDCONT",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "If no, please complete the section \"Study end\"",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "New appointment ",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has a new appointment been scheduled?",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "APPSCHED",
      "datasetName" : "FU",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Next visit date",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "NEXSVDTC",
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Tins delivery",
      "orderInForm" : 8,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FU",
      "metaData" : { }
    }, {
      "labelCode" : "Has the tins delivery request been processed? ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "TINRQPRO",
      "datasetName" : "DA",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Number of tins delivered",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "TINSREQ",
      "datasetName" : "DA",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "V5-J120",
  "num" : 70,
  "label" : "VISIT J120",
  "forms" : [ {
    "study" : null,
    "code" : "ANTHROPO",
    "labelCode" : "Anthropometric measures",
    "fields" : [ {
      "labelCode" : "ANTHROPOMETRIC MEASURES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Visit date  (dd/mm/yyyy)   : ",
      "orderInForm" : 3,
      "type" : "qdate",
      "variableName" : "SVSTDTC",
      "datasetName" : "SV",
      "metaData" : { }
    }, {
      "labelCode" : "Weight (kg)",
      "orderInForm" : 4,
      "type" : "qnumber",
      "variableName" : "WEIGHT",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Length (cm)",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "LENGTH",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Head circumference (cm)",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "HEADCIR",
      "datasetName" : "VS",
      "metaData" : { }
    }, {
      "labelCode" : "Please use qq.qq",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P1_FEED",
    "labelCode" : "Données d'alimentation",
    "fields" : [ {
      "labelCode" : "DONNEES D'ALIMENTATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Date du questionnaire  (dd/mm/yyyy)   : ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "QSDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez répondre aux questions suivantes en prenant en compte l’alimentation de votre enfant",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons par 24 heures (par jour)",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "FEEDBTL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Volume consommé par biberon (ml par biberon)",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "FEEDBVOL",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous avez ajouté un épaississant à au moins un des biberons, merci de compléter la section « Traitements et évènements marquants, commentaires »",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de biberons nocturnes (par nuit)",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "FEEDNIGH",
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "A quelle fréquence avez-vous utilisé une eau riche en magnésium (Hépar® par exemple), sur la période écoulée ?   ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "FEEDMGW2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQFF."
      }
    }, {
      "labelCode" : "A quelle fréquence votre enfant refuse-t-il le biberon ?",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "FEEDREF2",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "FRQ2FF."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "DIVERSIFJ120",
    "labelCode" : "Diversification",
    "fields" : [ {
      "labelCode" : "DIVERSIFICATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FEED",
      "metaData" : { }
    }, {
      "labelCode" : "Has the infant started diversification since the last visit?",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FEEDIV",
      "datasetName" : "FEED",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When (dd/mm/yyyy)  ?",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FDIVDTC",
      "datasetName" : "FEED",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "DIVERSIFJ90.FEEDIV = 0"
    },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P2_Regurg",
    "labelCode" : "Régurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATIONS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours : ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de régurgitations par jour ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "NBREG",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Volume des régurgitations",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "VOLREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGP."
      }
    }, {
      "labelCode" : "Votre enfant a-t-il eu des régurgitations en dehors des repas (au-delà de 1h après la fin du repas) :",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "REGAFML",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    }, {
      "labelCode" : "Après les repas, votre enfant a-t-il des régurgitations de petit volume, de manière continues (pendant plus de 30min) ?",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "ONGOREG",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "RGGFQP."
      }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "RegurgJ120",
    "labelCode" : "Regurgitations",
    "fields" : [ {
      "labelCode" : "REGURGITATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (Régurgitations) before completing this one",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the infant have regurgitation according to the adapted Rome IV criteria? \n",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "\nRegurgitation 4 or more times per day, for 1 or more weeks",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy)  ?  ",
      "orderInForm" : 9,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Adapted Vandenplas score, over the last 3 days",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "VANDN_SC",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "VND."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P3-Nconstip",
    "labelCode" : "Selles enfants non constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS NON CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant n'était pas constipé à la visite précédente. ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En moyenne sur les 3 derniers jours :",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Consistance typique des selles",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "STOOLS",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "STOOL2F."
      }
    }, {
      "labelCode" : " - Si vous avez coché 'Autre', merci de préciser",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "STOOLOTH",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Nombre de selles par jour ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STOOLFRQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 0"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P3-constip",
    "labelCode" : "Selles enfants constipés",
    "fields" : [ {
      "labelCode" : "SELLES - ENFANTS CONSTIPÉS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Merci de compléter ce formulaire uniquement si votre enfant était constipé à la visite précédente.",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sur les 7 derniers jours : ",
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles dures ",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "STNBHARD",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles moulées ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "STNBFOR",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles molles ",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "STNBLOOS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " - Nombre total de selles liquides ",
      "orderInForm" : 11,
      "type" : "qnumber",
      "variableName" : "STNBWAT",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " => Nombre total de selles sur la semaine ",
      "orderInForm" : 12,
      "type" : "qnumber",
      "variableName" : "STTOTNB",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Votre enfant a-t-il eu du mal à émettre ses selles ou l’émission de selles a-t-elle été douloureuse (par exemple, s'il a pleuré pendant) ? ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "PAINSTNB",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "PAIN2F."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 14,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous votre enfant a pris / utilisé un laxatif ou autre, depuis la dernière collecte de données, merci de le documenter dans la section « Traitements et évènements marquants, commentaires  » ",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : {
      "HIDEABLE" : "CONSTIP not found in Structure report value = 1"
    },
    "epro" : true
  }, {
    "study" : null,
    "code" : "STOOLJ120",
    "labelCode" : "Stools",
    "fields" : [ {
      "labelCode" : "STOOLS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Please consult the previous form (SELLES ENFANTS CONSTIPES / NON CONSTIPES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Is the infant constipated according to rome IV criteria",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 11,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P4-COLIC",
    "labelCode" : "Distension abdominale et flatulences - Comportement et pleurs",
    "fields" : [ {
      "labelCode" : "DISTENSION ABDOMINALE ET FLATULENCES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous fondant sur l’échelle de 0 à 10 ci-dessus, veuillez évaluer la sévérité des symptômes intestinaux, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité de la distension abdominale*  ",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "QSDIST",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " * La distension abdominale se manifeste par un ventre gonflé, tendu et dur au toucher",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Sévérité des gaz et flatulences** ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSGAS",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : " **Les flatulences se manifestent par l’expulsion de gaz hors du corps (par l'anus ou la bouche) et répandent une odeur désagréable et gênante ",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "COMPORTEMENT ET PLEURS ",
      "orderInForm" : 12,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer les épisodes de pleurs inexpliqués et d’agitation/irritabilité de votre enfant, en moyenne par jour, sur les 3 derniers jours :",
      "orderInForm" : 14,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes de pleurs inexpliqués* : ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCRYTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "*Ces épisodes surviennent sans cause évidente et les personnes qui s'occupent de l’enfant ne peuvent ni les prévenir, ni les résoudre.",
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée totale des épisodes d’agitation/irritabilité** ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSIRRTMC",
      "datasetName" : "QSCE",
      "metaData" : {
        "LIST_CODE" : "DUR."
      }
    }, {
      "labelCode" : "**Ces épisodes, correspondent aux moments où votre enfant ne dort pas et qu’il est agité, irritable ou grognon",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "COLICJ120",
    "labelCode" : "Colic and other GI symptoms",
    "fields" : [ {
      "labelCode" : "COLIC AND OTHER GI SYMPTOMS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Could you please consult the previous form (DISTENSION ABDOMINALE ET FLATULENCES) before completing this one",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "Does the child have colic according to Rome IV criteria?",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "FGID",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Has the disorder improved? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "FGIDIMPR",
      "datasetName" : "FACE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "When did the disorder improve (dd/mm/yyyy) ? ",
      "orderInForm" : 7,
      "type" : "qdate",
      "variableName" : "FGIDIDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    }, {
      "labelCode" : "When did the disorder disappear (dd/mm/yyyy) ?",
      "orderInForm" : 8,
      "type" : "qdate",
      "variableName" : "FGIDDDTC",
      "datasetName" : "FACE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P5-SLEEP",
    "labelCode" : "Sommeil",
    "fields" : [ {
      "labelCode" : "SOMMEIL",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez évaluer le sommeil de votre enfant, en moyenne sur les 3 derniers jours :",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Durée du sommeil par jour :  ",
      "orderInForm" : 6,
      "type" : "qtime",
      "variableName" : "QSLEETMC",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 7,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "En vous basant sur l’échelle ci-dessous :",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "Comment évalueriez-vous la qualité du sommeil de votre enfant entre 0 et 10 ? ",
      "orderInForm" : 9,
      "type" : "qnumber",
      "variableName" : "QSSLEEQ",
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : "   => Merci d'utiliser le format qq.q",
      "orderInForm" : 10,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSCE",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_GIGER",
    "labelCode" : "GIGER",
    "fields" : [ {
      "labelCode" : "GIGER - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Ce questionnaire porte sur les symptômes de reflux gastro-œsophagien et gastrointestinaux de votre enfant. Pour le remplir, considérez les éléments représentatifs chez votre enfant au cours de la semaine passée, puis cochez pour chaque item (de 1 à 36) la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Mon enfant..",
      "orderInForm" : 7,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "1. prend plaisir à manger.",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 1",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 1. My child enjoy eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "2. est calme et détendu lorsqu'il mange.",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 2",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 2. My child is calm and relaxed when eating.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "3. dort bien en étant allongé sur le dos.",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 3",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 3. My child sleeps well lying flat on his/her back.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "4. est facile à consoler lorsqu'il est contrarié (par exemple, il arrête de pleurer lorsqu'on le porte ou qu'on lui propose une tétine).",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 4",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 4. My child is easy to console when upset (for example, stops crying when held or offered a pacifier).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "5. mange suffisamment pour grandir comme il/elle le devrait.",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 5",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 5. My child eats enough to grow the way he/she should.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "6. manifeste sa faim avant les repas.",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 6",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 6. My child acts hungry before meals.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "7. a du mal à dormir.",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 7",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 7. My child has trouble sleeping.",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "8. a besoin d'être encouragé pour continuer à manger (par exemple, en le touchant ou en lui parlant).",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 8",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 8. My child needs to be encouraged to keep eating (such as, by touching or talking).",
        "QSSCAT" : " Self-Regulation Abilities",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "9. a besoin de roter plus d'une fois avant la fin du repas.",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 9",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 9. My child needs to be burped more than once before the end of feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "10. a beaucoup de gaz.",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 10",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 10. My child is very gassy.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "11. régurgite pendant le repas.",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 11",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 11. My child spits up during feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "12. régurgite entre les repas.",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 12",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 12. My child spits up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "13. vomit entre les repas.",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 13",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 13. My child throws up in between feedings.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "14. semble présenter des signes d’inconfort après les repas.",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 14",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 14. My child seems uncomfortable after feeding.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "15. a le hoquet.",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 15",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 15. My child gets the hiccups.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "16. présente des signes d’inconfort s'il est allongé après avoir mangé.",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 16",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 16. My child is uncomfortable if laid flat after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "17. semble avoir des gargouillements ou avoir besoin de tousser ou de se racler la gorge pendant ou après avoir mangé.",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 17",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 17. My child sounds gurgly or like they need to cough or clear their throat during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "18. devient raide/rigide pendant ou après avoir mangé.",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 18",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 18. My child becomes stiff/rigid during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "19. se cambre pendant ou après avoir mangé.",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 19",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 19. My child arches back during or after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "20. a le ventre gonflé (gros ou dur) après avoir mangé.",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 20",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 20. My child gets a bloated (big or hard) tummy after eating.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "21. semble s'étouffer entre les prises alimentaires lorsqu'il n'y a rien dans sa bouche.",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 21",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 21. My child gags in between feedings when there is nothing in his/her mouth.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "22. rougit, peut pleurer pendant la défécation / l’émission de selles.",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 22",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 22. My child turns red in face, may cry with pooping/stooling.",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "23. s’énerve pendant les repas (gémit, pleure, devient grognon).",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 23",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 23. My child becomes upset during feeding (whines, cries, gets fussy).",
        "QSSCAT" : " Common GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "24. change de couleur (par exemple, il devient bleu, gris, violet ou rouge foncé).",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 24",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 24. My child changes color (for example, turns blue, gray, purple, or dark red).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "25. arrête de respirer ou a du mal à respirer pendant les repas.",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 25",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 25. My child stops breathing or struggles to breathe during feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "26. arrête de respirer ou a du mal à respirer entre les repas.",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 26",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 26. My child stops breathing or struggles to breathe in between feedings/mealtime.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "27. a des selles noires très foncées.",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 27",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 27. My child has very dark black poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "28. a des selles très claires ou blanches.",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 28",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 28. My child has very light tan or white poop/stools.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "29. a du sang ou du mucus dans les selles.",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 29",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 29. My child has blood or mucous in poop/stool.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "30. régurgite ou vomit du sang.",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 30",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 30. My child has blood in their vomit/spit-up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "31. essaie de vomir ou semble sur le point de vomir, mais rien ne sort.",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 31",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 31. My child tries to vomit or looks like they are going to vomit, but nothing comes up.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "32. émet des sons différents pendant ou après le repas (par exemple, sa voix devient rauque, aiguë ou silencieuse).",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 32",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 32. My child sounds different during or after eating (for example, voice becomes hoarse, high-pitched, or quiet).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "33. refuse de manger.",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 33",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 33. My child refuses to eat.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "34. a la diarrhée.",
      "orderInForm" : 41,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 34",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 34. My child has diarrhea.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "35. tousse ou s'étouffe en dehors des repas.",
      "orderInForm" : 42,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 35",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 35. My child coughs or chokes when not eating.",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "36. a du mal à évacuer la totalité de ses selles (par exemple, évacue de petites selles à chaque fois ou défèque mais il y en a encore à l'intérieur).",
      "orderInForm" : 43,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "GIGER",
      "metaData" : {
        "QSSEQ" : " 36",
        "LIST_CODE" : "GIGPRO.",
        "QSTEST" : " 36. My child has trouble getting all of their poop/stool out (for example, he/she poops a little at a time or poops, but there is still more inside).",
        "QSSCAT" : " Compelling GI and GER Symptoms",
        "QSCAT" : " GIGER"
      }
    }, {
      "labelCode" : "GIGER TOTAL",
      "orderInForm" : 44,
      "type" : "qnumber",
      "variableName" : "GIGER_SC",
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 45,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "Si vous souhaitez expliquer certaines de vos réponses ou apporter des informations complémentaires,",
      "orderInForm" : 46,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "veuillez le faire ici",
      "orderInForm" : 47,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "GIGER",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 48,
      "type" : "qtext",
      "variableName" : "GIGERCO",
      "datasetName" : "GIGER",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "P_QUALIN",
    "labelCode" : "QUALIN",
    "fields" : [ {
      "labelCode" : "QUALIN - QUESTIONNAIRE A REMPLIR PAR LES PARENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Nous souhaitons évaluer la qualité de vie de votre enfant, au cours de la semaine passée. Pour chacune des 34 affirmations, merci de cocher la case correspondante à votre réponse.",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "Afin de visualiser l’ensemble des réponses (6 par item), merci d’utiliser votre téléphone en mode paysage. ",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QUALIN",
      "metaData" : { }
    }, {
      "labelCode" : "1. Il mange bien ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  1",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 1.Il mange bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "2. Il a bonne mine ",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  2",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 2. Il a bonne mine ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "3. Il est éveillé ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  3",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 3. Il est éveillé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "4. Il a souvent mal quelque part ",
      "orderInForm" : 10,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  4",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 4. Il a souvent mal quelque part ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "5. Il joue bien ",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  5",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 5. Il joue bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "6. Il est nerveux ",
      "orderInForm" : 12,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  6",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 6. Il est nerveux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "7. Il aime bien qu'on s'occupe de lui ",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  7",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 7. Il aime bien qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "8. Il est gai, rit ou sourit facilement ",
      "orderInForm" : 14,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  8",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 8. Il est gai, rit ou sourit facilement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "9. Il se laisse volontiers approcher ",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  9",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 9. Il se laisse volontiers approcher ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "10. Il a toujours besoin qu'on s'occupe de lui ",
      "orderInForm" : 16,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  10",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 10. Il a toujours besoin qu'on s'occupe de lui ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "11. Il a un bon entourage familial ",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  11",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 11. Il a un bon entourage familial ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "12. Il se développe bien, est en bonne santé ",
      "orderInForm" : 18,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  12",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 12. Il se développe bien, est en bonne santé ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "13. Il est joueur, coquin ",
      "orderInForm" : 19,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  13",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 13. Il est joueur, coquin ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "14. Il semble souvent inquiet ",
      "orderInForm" : 20,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  14",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 14. Il semble souvent inquiet ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "15. Il cherche à attirer l'attention ",
      "orderInForm" : 21,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  15",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 15. Il cherche à attirer l'attention ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "16. Il est tonique, plein de vitalité ",
      "orderInForm" : 22,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  16",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 16. Il est tonique, plein de vitalité ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "17. Il pleure dès qu'il est seul ",
      "orderInForm" : 23,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  17",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 17. Il pleure dès qu'il est seul ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "18. Il aime jouer ",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  18",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 18. Il aime jouer ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "19. Il s'adapte facilement aux changements ",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  19",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 19. Il s'adapte facilement aux changements ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "20. Il est pénible ",
      "orderInForm" : 26,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  20",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 20. Il est pénible ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "21. Il gazouille bien ",
      "orderInForm" : 27,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  21",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 21. Il gazouille bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "22. Il est curieux, s'intéresse, est ouvert à son environnement ",
      "orderInForm" : 28,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  22",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 22. Il est curieux, s'intéresse, est ouvert à son environnement ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "23. Il demande beaucoup les bras ",
      "orderInForm" : 29,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  23",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 23. Il demande beaucoup les bras ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "24. Il est gracieux ",
      "orderInForm" : 30,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  24",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 24. Il est gracieux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "25. Il aime voir du monde ",
      "orderInForm" : 31,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  25",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 25. Il aime voir du monde ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "26. Il y a une bonne entente entre ses parents ",
      "orderInForm" : 32,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  26",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 26. Il y a une bonne entente entre ses parents ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "27. Il est souvent malade ",
      "orderInForm" : 33,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  27",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 27. Il est souvent malade ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "28. Il dort bien ",
      "orderInForm" : 34,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  28",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 28. Il dort bien ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "29. Il a un rythme de vie équilibré ",
      "orderInForm" : 35,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  29",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 29. Il a un rythme de vie équilibré ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "30. Il pleure souvent ",
      "orderInForm" : 36,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  30",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 30. Il pleure souvent ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "31. Son mode de garde est satisfaisant ",
      "orderInForm" : 37,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  31",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 31. Son mode de garde est satisfaisant ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "32. Il est câlin, affectueux ",
      "orderInForm" : 38,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  32",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 32. Il est câlin, affectueux ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "33. Quand il pleure, on comprend bien pourquoi ",
      "orderInForm" : 39,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  33",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 33. Quand il pleure, on comprend bien pourquoi ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "34. Il n'est pas sauvage ",
      "orderInForm" : 40,
      "type" : "list",
      "variableName" : "QSORRES",
      "datasetName" : "QUALIN",
      "metaData" : {
        "QSSEQ" : "  34",
        "LIST_CODE" : "QULN.",
        "QSTEST" : " 34. Il n'est pas sauvage ",
        "QSCAT" : " QUALIN"
      }
    }, {
      "labelCode" : "QUALIN TOTAL SCORE",
      "orderInForm" : 41,
      "type" : "qnumber",
      "variableName" : "QUALIN_SC",
      "datasetName" : "QUALIN",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "GIGER_QUALIN_SCORE",
    "labelCode" : "GIGER and QUALIN scores",
    "fields" : [ {
      "labelCode" : "GIGER AND QUALIN SCORES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Theoretical date of questionnaires filling",
      "orderInForm" : 5,
      "type" : "qdate",
      "variableName" : "QSTDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "Date of questionnaires filling",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "QSDTC_R",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "GIGER score",
      "orderInForm" : 7,
      "type" : "qnumber",
      "variableName" : "GIGER_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    }, {
      "labelCode" : "QUALIN score",
      "orderInForm" : 8,
      "type" : "qnumber",
      "variableName" : "QUALIN_RSC",
      "datasetName" : "QS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P6-SATISF",
    "labelCode" : "Satisfaction des parents",
    "fields" : [ {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de la formule",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quelle est votre satisfaction concernant : ",
      "orderInForm" : 4,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "img",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "L’utilisation de la formule (préparation, consistance, dilution…) ? ",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "QSATFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : "Acceptabilité de la formule par votre enfant (goût, durée du biberon…)",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "QSACFORM",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "SAT."
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "SATISFACTION DES PARENTS : vis-à-vis de l’évolution des troubles",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Quel est votre avis concernant l'évolution des différents troubles ci-dessous ?",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des régurgitations :",
      "orderInForm" : 13,
      "type" : "list",
      "variableName" : "QSREGEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTR."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand  (dd/mm/yyyy) ?",
      "orderInForm" : 14,
      "type" : "qdate",
      "variableName" : "QREGIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution de la constipation :",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "QSCONSEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCP."
      }
    }, {
      "labelCode" : " =>Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 16,
      "type" : "qdate",
      "variableName" : "QCONIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution des coliques :",
      "orderInForm" : 17,
      "type" : "list",
      "variableName" : "QSCOLEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "IMPVTCL."
      }
    }, {
      "labelCode" : " => Si amélioration, depuis quand (dd/mm/yyyy) ?",
      "orderInForm" : 18,
      "type" : "qdate",
      "variableName" : "QCOLIDTC",
      "datasetName" : "QSSAT",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  }, {
    "study" : null,
    "code" : "EFFIC",
    "labelCode" : "Investigator's evaluation of the evolution of FGIDs",
    "fields" : [ {
      "labelCode" : "EVOLUTION OF FUNCTIONAL GASTROINTESTINAL DISORDERS (FGIDs)",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSSAT",
      "metaData" : { }
    }, {
      "labelCode" : "Evolution of regurgitation",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "REGUREV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of constipation",
      "orderInForm" : 4,
      "type" : "list",
      "variableName" : "CONSTEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    }, {
      "labelCode" : "Evolution of colic",
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "COLICEV",
      "datasetName" : "QSSAT",
      "metaData" : {
        "LIST_CODE" : "EFF."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "P7-TRTevents",
    "labelCode" : "Traitements, évènements, commentaires",
    "fields" : [ {
      "labelCode" : "TRAITEMENTS ET ÉVÈNEMENTS MARQUANTS, COMMENTAIRES",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Médicaments ou compléments donnés à l'enfant depuis la dernière fois :",
      "orderInForm" : 4,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Veuillez indiquer ci-dessous les informations (date, heure, nom/type, dosage, fréquence, indication…) ",
      "orderInForm" : 5,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "relatives aux médicaments ou compléments utilisés depuis la dernière fois.",
      "orderInForm" : 6,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "QSCOCM",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : épaississants, probiotiques, paracétamol …",
      "orderInForm" : 8,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 9,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Tout évènement marquant ou commentaire ou autre information rconcernant l'enfant depuis la dernière fois :",
      "orderInForm" : 10,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Vous pouvez indiquer ci-dessous tout évènement marquant ou toute information relative à votre enfant ",
      "orderInForm" : 12,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "(même sans lien avec l’étude)",
      "orderInForm" : 13,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qtext",
      "variableName" : "QSCOAE",
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : "Exemples : fièvre, poussées dentaires, fracture, réaction allergique, commentaire sur une des réponses de l’ePRO",
      "orderInForm" : 15,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "QSCO",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : true
  } ]
}, {
  "code" : "Concomitant treatments",
  "num" : 80,
  "label" : "CONCOMITANT TREATMENTS",
  "forms" : [ {
    "study" : null,
    "code" : "CM",
    "labelCode" : "Concomitant treatments",
    "fields" : [ {
      "labelCode" : "CONCOMITANT TREATMENTS",
      "orderInForm" : 1,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "CM",
      "metaData" : { }
    }, {
      "labelCode" : "Before completing or updating this form, could you please consult informations reported in the form \"Traitements, évènements, commentaires\" (if any) of the current visit and the previous visit",
      "orderInForm" : 3,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "CM",
      "metaData" : { }
    }, {
      "labelCode" : "Treatment / medication taken  (including thickening agent, pre-probiotics, laxative…)",
      "orderInForm" : 4,
      "type" : "qtext",
      "variableName" : "CMTRT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Route",
      "orderInForm" : 5,
      "type" : "qlist",
      "variableName" : "CMROUTE",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "ROUTE.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Dose",
      "orderInForm" : 6,
      "type" : "qnumber",
      "variableName" : "CMDOSTXT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Dose Unit",
      "orderInForm" : 7,
      "type" : "qlist",
      "variableName" : "CMDOSU",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "UNIT.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "if other: Unit",
      "orderInForm" : 8,
      "type" : "qtext",
      "variableName" : "CMDOSUOT",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Frequency",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "CMDOSFRQ",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Start date (dd/mm/yyyy) ",
      "orderInForm" : 10,
      "type" : "qdate",
      "variableName" : "CMSTDTC",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Ongoing",
      "orderInForm" : 11,
      "type" : "list",
      "variableName" : "CMONGO",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "End date (dd/mm/yyyy) ",
      "orderInForm" : 12,
      "type" : "qdate",
      "variableName" : "CMENDTC",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "Indication",
      "orderInForm" : 14,
      "type" : "qlist",
      "variableName" : "CMINDC",
      "datasetName" : "CM",
      "metaData" : {
        "LIST_CODE" : "INDIC2F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "if Indication is AE, please specify : - AE number 1",
      "orderInForm" : 15,
      "type" : "qnumber",
      "variableName" : "AESEQ_1",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : " - AE number 2 (if any)",
      "orderInForm" : 16,
      "type" : "qnumber",
      "variableName" : "AESEQ_2",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    }, {
      "labelCode" : "If Indication is MH, Prophylaxis or Other, please specify",
      "orderInForm" : 17,
      "type" : "qtext",
      "variableName" : "CMINDCSP",
      "datasetName" : "CM",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "Treatment"
      }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "Adverse events",
  "num" : 90,
  "label" : "ADVERSE EVENTS",
  "forms" : [ {
    "study" : null,
    "code" : "AE",
    "labelCode" : "Adverse events",
    "fields" : [ {
      "labelCode" : "ADVERSE EVENTS",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : "Description",
      "orderInForm" : 3,
      "type" : "qtext",
      "variableName" : "AETERM",
      "datasetName" : "AE",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Start date (dd/mm/yyyy) ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "AESTDTC",
      "datasetName" : "AE",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 5,
      "type" : "list",
      "variableName" : "AEONGO",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "End date  (dd/mm/yyyy) ",
      "orderInForm" : 6,
      "type" : "qdate",
      "variableName" : "AEENDTC",
      "datasetName" : "AE",
      "metaData" : {
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Severity ",
      "orderInForm" : 7,
      "type" : "list",
      "variableName" : "AESEV",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "SEV.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Relation to the research / study",
      "orderInForm" : 8,
      "type" : "list",
      "variableName" : "AEREL",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "REL.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Relation to the product ",
      "orderInForm" : 9,
      "type" : "list",
      "variableName" : "AERELSP",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "REL.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Action(s) taken",
      "orderInForm" : 10,
      "type" : "qmulti",
      "variableName" : "AEACN1",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "YES1F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "*",
      "orderInForm" : 11,
      "type" : "qmulti",
      "variableName" : "AEACN2",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "YES2F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "*",
      "orderInForm" : 12,
      "type" : "qmulti",
      "variableName" : "AEACN3",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "YES3F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "*",
      "orderInForm" : 13,
      "type" : "qmulti",
      "variableName" : "AEACN4",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "YES4F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "*",
      "orderInForm" : 14,
      "type" : "qmulti",
      "variableName" : "AEACN5",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "YES5F.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : "Serious adverse events",
      "orderInForm" : 15,
      "type" : "list",
      "variableName" : "AESER",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "NOYES.",
        "GROUPE_REPEATED" : "1",
        "LABEL_FOR_GROUPE_REPEATED" : "ADVERSE EVENT"
      }
    }, {
      "labelCode" : null,
      "orderInForm" : 16,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 17,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : "If AE is a serious adverse event (SAE):",
      "orderInForm" : 18,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : "Please download and complete the SAE form (link to the pdf or word document below*).",
      "orderInForm" : 19,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 20,
      "type" : "URL",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 21,
      "type" : "URL",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : "Please send this form within 24h of becoming aware of the SAE to \"pharmacovigilance@novalac.com\". Then, complete the \"Serious adverse event\" form in the eCRF.\"",
      "orderInForm" : 22,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 23,
      "type" : "text",
      "variableName" : null,
      "datasetName" : "AE",
      "metaData" : { }
    }, {
      "labelCode" : "Would you like to load the SAE form no.2?",
      "orderInForm" : 24,
      "type" : "list",
      "variableName" : "SAEFORM2",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Would you like to load the SAE form no.3?",
      "orderInForm" : 25,
      "type" : "list",
      "variableName" : "SAEFORM3",
      "datasetName" : "AE",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    } ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "SAE",
    "labelCode" : null,
    "fields" : [ ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "SAE",
    "labelCode" : null,
    "fields" : [ ],
    "metaData" : { },
    "epro" : false
  }, {
    "study" : null,
    "code" : "SAE",
    "labelCode" : null,
    "fields" : [ ],
    "metaData" : { },
    "epro" : false
  } ]
}, {
  "code" : "Study end",
  "num" : 100,
  "label" : "END OF STUDY",
  "forms" : [ {
    "study" : null,
    "code" : "END",
    "labelCode" : "Completion / Discontinuation (eCRF – Investigateur) ",
    "fields" : [ {
      "labelCode" : "COMPLETION / DISCONTINUATION",
      "orderInForm" : 2,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DS",
      "metaData" : { }
    }, {
      "labelCode" : "Completion up to the end of the study",
      "orderInForm" : 3,
      "type" : "list",
      "variableName" : "DSWITH",
      "datasetName" : "DS",
      "metaData" : {
        "LIST_CODE" : "NOYES."
      }
    }, {
      "labelCode" : "Date of the last consumption of study formula (dd/mm/yyyy) ",
      "orderInForm" : 4,
      "type" : "qdate",
      "variableName" : "DAENDTC",
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : "Reason for discontinuation",
      "orderInForm" : 5,
      "type" : "title",
      "variableName" : null,
      "datasetName" : "DS",
      "metaData" : { }
    }, {
      "labelCode" : "Reason for discontinuation",
      "orderInForm" : 6,
      "type" : "list",
      "variableName" : "DSREAS",
      "datasetName" : "DS",
      "metaData" : {
        "LIST_CODE" : "REAS."
      }
    }, {
      "labelCode" : "If investigator's decision, please specify",
      "orderInForm" : 7,
      "type" : "qtext",
      "variableName" : "DSREASSP",
      "datasetName" : "DS",
      "metaData" : { }
    }, {
      "labelCode" : "Name of the formula prescribe after this visit",
      "orderInForm" : 8,
      "type" : "qtext",
      "variableName" : "FORNAME",
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : "Brand of the formula prescribe after this visit",
      "orderInForm" : 9,
      "type" : "qtext",
      "variableName" : "FORBRAND",
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : "Number of tins retrieved",
      "orderInForm" : 10,
      "type" : "qnumber",
      "variableName" : "TINSRETR",
      "datasetName" : "DA",
      "metaData" : { }
    }, {
      "labelCode" : null,
      "orderInForm" : 11,
      "type" : "text",
      "variableName" : null,
      "datasetName" : null,
      "metaData" : { }
    }, {
      "labelCode" : "GENERAL COMMENTS ON THE CRF (IF ANY)",
      "orderInForm" : 12,
      "type" : "qtext",
      "variableName" : "DSCOM",
      "datasetName" : "DS",
      "metaData" : { }
    } ],
    "metaData" : { },
    "epro" : false
  } ]
} ]